import { combineReducers } from 'redux';

import samplesReducer from '../components/SampleSubmission/samples-reducer';
import cropsReducer from '../components/SampleSubmission/crop-reducer';
import tagsReducer from '../components/SampleSubmission/tag-reducer';
import farmsReducer from '../components/FieldManagement/farmsReducer';
import fieldsReducer from '../components/FieldManagement/fieldsReducer';
import permissionReducer from '../components/Growers/permissionsReducer';
import { indicatorReducer } from '../components/Analytics/indicator-reducer';

const entitiesReducer = combineReducers({
  samples: samplesReducer,
  crops: cropsReducer,
  tags: tagsReducer,
  indicators: indicatorReducer,
  farms: farmsReducer,
  fields: fieldsReducer,
  permissions: permissionReducer
});

export default entitiesReducer;
